import React from "react";
import styles from "./play_btn_with_ripple.module.scss";

export const PlayButtonWithRipple = ({
  colorOrange,
  medium,
  ripple = true,
  small,
  ...props
}) => {
  return (
    <div
      className={`${styles.play_btn} ${colorOrange ? `${styles.orange}` : ""} ${
        medium ? `${styles.medium}` : ""
      } ${small ? `${styles.small}` : ""}`}
      {...props}
    >
      <div className={styles.arrow_right}></div>
      {ripple && <span className={styles.ripple_effect}></span>}
    </div>
  );
};

export default PlayButtonWithRipple;
